import React from 'react';
import type { CellRenderProps } from '@axiom/ui';
import { Link } from 'react-router';

import type { CandidateDetail } from '../../api/chat-api';

/**
 * How many people have left feedback, linked to the feedback tab of the candidate's profile.
 *
 * `/feedback` on the profile's own route: `TalentProfile` reads the tab out of the pathname and the
 * talent-detail route matches on `*`, so the deep link opens that tab directly.
 */
export const MatchGridFeedbackResponses = ({
  data,
}: CellRenderProps<CandidateDetail>) => {
  const responses = data.numberOfFeedbackResponses;

  // Nothing to open on zero, so the count stands as plain text rather than a link to an empty tab.
  if (!data.id || responses === 0) return responses;

  return (
    <Link
      data-test={`CANDIDATE_FEEDBACK_LINK_${data.id}`}
      to={`/talent-detail/${data.id}/feedback`}
      rel="noopener noreferrer"
      target="_blank"
    >
      {responses}
    </Link>
  );
};
